import { render, staticRenderFns } from "./EcoRating.vue?vue&type=template&id=3e8d1a86"
import script from "./EcoRating.vue?vue&type=script&lang=js"
export * from "./EcoRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports